import React from 'react';
import { useTranslation } from 'react-i18next';

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLng = i18n.language === 'en' ? 'zh' : 'en';
    i18n.changeLanguage(newLng);
  };

  return (
    <button
      onClick={toggleLanguage}
      className="px-3 py-1 text-sm font-medium text-on-primary hover:opacity-80 transition-opacity"
      aria-label="Toggle language"
    >
      {i18n.language === 'en' ? 'EN | 中文' : '中文 | EN'}
    </button>
  );
}
